const homepageStyles = (theme) => {
  return {
    root: {
      width: '100%',
    },
    button: {
      marginTop: '1rem',
      marginBottom: '1rem',
      backgroundColor: 'green',
      marginLeft: '0.5rem',
      marginRight: '0.5rem',
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      borderRadius: theme.spacing(5),
      textTransform: 'capitalize',
    },
  };
};

export default homepageStyles;

export const eventCardStyles = (theme) => {
  return {
    gridOccupy: {
      width: '100%',
      overflow: 'hidden',
    },
    root: {
      marginTop: theme.spacing(1),
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      maxHeight: 140,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      borderRadius: theme.spacing(1),
    },
    actionArea: {
      display: 'flex',
      // flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
    },
    image: {
      maxHeight: 140,
      width: theme.spacing(15),
      height: theme.spacing(15),
      objectFit: 'cover',
      overflow: 'hidden',
      borderRadius: theme.spacing(2),
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'baseline',
      flex: 4,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(0.5),
    },
    contentRight: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'baseline',
      width: '200px',
      // border:'1px solid black',
      // paddingLeft: theme.spacing(),
      // paddingRight: theme.spacing(),
      marginBottom: '8px',
      [theme.breakpoints.down('sm')]: {
        width: '150px',
      },
      [theme.breakpoints.down('xs')]: {
        width: '90px',
      },
    },
    detailsCont: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingTop: theme.spacing(),
    },
    eventTitle: {
      textTransform: 'capitalize',
      textOverflow: 'ellipsis',
      maxWidth: theme.spacing(60),
      msTextOverflow: 'ellipsis',
      overflowWrap: 'anywhere',
    },
    eventDesc: {
      overflowWrap: 'anywhere',
      overflow: 'hidden',
      maxHeight: 40,
      maxWidth: theme.spacing(60),
      textOverflow: 'ellipsis',
      msTextOverflow: 'ellipsis',
    },
    dateCont: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    priceCont: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: '18px',
    },
    dummy: {
      width: theme.spacing(1),
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      minWidth: 127,
      marginLeft: '-3px',
    },
    button: {
      textTransform: 'capitalize',
      marginLeft: '0px !importatnt',
    },
    cardTitle: {
      whiteSpace: 'nowrap',
      maxWidth: '200px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: '22px',
      fontWeight: '500',
      // border: '2px solid black',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '170px',
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: '135px !important',
      },
    },
    descriptionContainer: {
      marginLeft: '3px',
      marginBottom: '10px',
      marginTop: '-3px',
    },
    cardDescription: {
      whiteSpace: 'nowrap',
      maxWidth: '450px',
      maxHeight: '40px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      // border: '1px solid black',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '200px !important',
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: '135px !important',
      },
      [theme.breakpoints.down('md')]: {
        maxWidth: '250px',
      },
    },
    cancelledText: {
      border: '2px red solid',
      color: 'red',
      padding: '2px',
      borderRadius: '5px',
    },
  };
};
